import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

/**
 * This component will fetch and load svg definitions from CDN.
 * Use this component at the top of your HTML in order to use svg"s in your application.
 * @example return (
 *   <div className="application">
 *     <SvgDefs/>
 *     <div>....</div>
 *   </div>
 * );
 */
export const SvgDefs = () => {
  const [svg, setSvg] = useState(null);

  useEffect(() => {
    let loaded = false;
    fetch('https://cdn.cm.be/@cm/icons/svg-defs.svg')
      .then(response => response.text())
      .then(text => {
        if (!loaded) setSvg(text);
      })
      .catch(console.error);
    return () => { loaded = true; };
  }, []);

  return (
    <div style={{ display: 'none' }} dangerouslySetInnerHTML={{ __html: svg }}/>
  );
};

/**
 * Render icons using a reference (<use href="#<some-id>" />) to svg definitions from CDN.
 * @param {{
 *   name: string,
 *   className?: string,
 *   onClick?
 * }} props
 * @return {JSX.Element}
 * @constructor
 * @example return (
 *   <Icon name="calendar" className="w-5 h-5 text-green text-lg mr-1" />
 * );
 */
const Icon = (props) => {
  const {
    className,
    name,
    onClick,
  } = props;

  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <svg
      className={twMerge('inline fill-current w-5 h-5', className)}
      xmlns="http://www.w3.org/2000/svg"
      onClick={handleClick}
    >
      <use href={`#${name}`} />
    </svg>
  );
};

Icon.propTypes = {
  /**
   * Extend the styles applied to the component.
   */
  className: PropTypes.string,
  /**
   * Name of the icon.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
};

export { Icon };
